import { render, staticRenderFns } from "./RegionTeamMemberList.vue?vue&type=template&id=2a5e56bd"
import script from "./RegionTeamMemberList.vue?vue&type=script&lang=js"
export * from "./RegionTeamMemberList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports